import { useEffect } from 'react';
import { states } from '@/constants/lifecycle';
import { hasMinimumLength } from '@/utils/resultsHelper';
import fetch from '@/hooks/fetch';
import { userGroupSourceCodeFromUrl } from '../helper';
import { readUsergroupActions } from '../constants';

const useFetchUsersGroups = (fn, category, readStatus, user) => {
  useEffect(() => {
    if (readStatus === states.NONE && hasMinimumLength(user?.uuid)) {
      fn(category, user, 1, 10000);
    }
  }, []);
};

const useFetchOrNewUserGroup = (fn, newGroup, category, code, readStatus, url, isNew, isDuplicate) => {
  useEffect(() => {
    if (isDuplicate) {
      const userGroupSourceCode = userGroupSourceCodeFromUrl(url);
      newGroup(category, code, userGroupSourceCode);
    } else if (readStatus === states.NONE) {
      fn(category, code, isNew);
    }
  }, []);
};

export default {
  useFetchUsergroups: ({ category }, readStatus) => fetch.useFetchDispatch(
    readUsergroupActions.FETCH_USERGROUPS,
    readStatus,
    { category },
  ),
  useFetchUsersGroups,
  useFetchOrNewUserGroup,
};
